module.exports = __webpack_public_path__ + "static/media/wmgr_kit.2f2cf7fe.png";